// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { DAMAGE_CASE_TOGGLE_TRADE } from "./constants"

export function toggleTrade(caseId, code) {
  return {
    type: DAMAGE_CASE_TOGGLE_TRADE,
    data: { caseId, code },
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case DAMAGE_CASE_TOGGLE_TRADE:
      const { caseId, code } = action.data
      const damageCase = state.unsentCases[caseId]
      const tradeCodes = damageCase.tradeCodes.filter(c => c !== code)
      if (tradeCodes.length === damageCase.tradeCodes.length) tradeCodes.push(code)
      const alteredCase = { ...damageCase, tradeCodes }
      return {
        ...state,
        unsentCases: { ...state.unsentCases, [caseId]: alteredCase },
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/features/damage-case/redux/toggleTrade.js